<div class="sale2-listings-container" dir="rtl">
  <header class="listings-header">
    <div class="header-content" (click)="navigateToPage()">
      <div class="header-icon">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
          <circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6"/>
        </svg>
      </div>
      <div>
        <h2>יד שניה</h2>
        <!-- Count folded into the subtitle: it's passive information,
        so it belongs with the description rather than occupying
        its own pill alongside the real actions. -->
        <p class="subtitle">
          <span class="subtitle-text">מוצרים, אומנות, אופניים ועוד</span>@if (items.length) {
          <span
          class="subtitle-count">{{ items.length }} מודעות</span>
        }
      </p>
    </div>
  </div>
  <div class="header-actions">
    @if (items.length > 0) {
      <div class="scroll-arrows">
        <button class="arrow-btn" (click)="scrollLeft()" aria-label="מודעות יד שנייה הבאות">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 18l6-6-6-6"/></svg>
        </button>
        <button class="arrow-btn" (click)="scrollRight()" aria-label="מודעות יד שנייה הקודמות">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M15 18l-6-6 6-6"/></svg>
        </button>
      </div>
    }
    <button type="button" class="view-all-btn" (click)="navigateToPage()">לכל המודעות</button>
  </div>
</header>

@if (isLoading) {
  <div class="loading-state">
    <div class="dot-loader"><span></span><span></span><span></span></div>
    <p>טוען מוצרים...</p>
  </div>
}

@if (error && !isLoading) {
  <div class="error-state">
    <p>אופס! משהו השתבש</p>
    <button (click)="loadItems()" class="retry-btn">נסה שוב</button>
  </div>
}

@if (!isLoading && !error && items.length > 0) {
  <div class="scroll-wrapper">
    <div class="sale2-track" #sale2Track dragScroll>
      @for (item of items; track item; let i = $index) {
        <div
          class="sale2-card"
          [class.promoted]="isPromoted(item)"
          [style.animation-delay]="i * 60 + 'ms'"
          (click)="openPage(item.id)"
          role="button"
          tabindex="0"
          [attr.aria-label]="'פתיחת מודעת יד שנייה: ' + item.name"
          (keydown.enter)="openPage(item.id)"
          (keydown.space)="openPage(item.id); $event.preventDefault()"
          >
          <!-- Internal (admin) ad linked to this category — generic layout, -->
          <!-- since it doesn't have any of the sale2-specific fields below -->
          @if (isInternalAd(item)) {
            <div class="card-image">
              <img
                [src]="item.images[0]?.image || 'https://placehold.co/400x260/e8e4df/8a8580?text=🛒'"
                [alt]="item.name"
                (error)="onImageError($event)"
                />
              <span class="price-tag" [class.no-price]="!item.price">{{ formatPrice(item.price) }}</span>
            </div>
            <div class="card-body">
              <h3 class="item-name">{{ item.name }}</h3>
              @if (item.description) {
                <p class="internal-ad-desc">{{ item.description }}</p>
              }
              @if (item.city) {
                <div class="meta location">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/></svg>
                  {{ item.city.nameHe }}
                </div>
              }
              <div class="card-footer">
                <span class="seller">{{ item.userContactDetails?.contactPerson }}</span>
                <app-contact-menu
                  [phone]="item.userContactDetails?.phoneNumber || ''"
                  [itemName]="item.name"
                  [itemId]="item.id"
                  [accentColor]="'#7c3aed'"
                ></app-contact-menu>
              </div>
            </div>
          } @else {
            <!-- Image -->
            <div class="card-image">
              <img
                [src]="item.images[0]?.image || 'https://placehold.co/400x260/e8e4df/8a8580?text=🛒'"
                [alt]="item.name"
                (error)="onImageError($event)"
                />
              <span class="price-tag" [class.no-price]="!item.price">{{ formatPrice(item.price) }}</span>
              @if (isPromoted(item)) {
                <span class="ads-tag">{{ getAdsBadge(item.adsRoute.level) }}</span>
              }
              <app-card-biz-badges [item]="item"></app-card-biz-badges>
            </div>
            <!-- Body -->
            <div class="card-body">
              <h3 class="item-name">{{ item.name }}</h3>
              <div class="meta">
                <span>{{ item.sconderyCategory.name }}</span>
                <span class="dot"></span>
                <span>{{ item.subCategory.subCategoryName }}</span>
              </div>
              <div class="meta location">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/></svg>
                {{ item.City.nameHe }}
              </div>
              <div class="chips">
                <span class="chip status">{{ item.ProductStatus.statusName }}</span>
                @if (item.DeliveryOffer) {
                  <span class="chip">🚚 משלוח</span>
                }
                @if (item.average_rating) {
                  <span class="chip rating">
                    ⭐ {{ item.average_rating }} ({{ item.total_ratings }})
                  </span>
                }
              </div>
              <div class="card-footer">
                <app-card-dealer [item]="item"></app-card-dealer>
                <app-contact-menu
                  [phone]="item.userContactDetails?.phoneNumber || ''"
                  [itemName]="item.name"
                  [itemId]="item.id"
                  [accentColor]="'#7c3aed'"
                ></app-contact-menu>
              </div>
            </div>
          }
        </div>
      }
    </div>
  </div>
}

@if (!isLoading && !error && items.length === 0) {
  <div class="empty-state">
    <p>לא נמצאו מוצרים</p>
  </div>
}
</div>
